import Image from 'next/image';

import { cn } from '~/lib/utils';
import { BlogCategoryFragment } from '~/server/generated/contentful-graphql';

export function BlogCategory({ category, className }: { className?: string; category: BlogCategoryFragment }) {
  const hasContent = category.title || category.icon?.url || category.color;

  if (!hasContent) return null;

  return (
    <div
      className={cn('text-(--category-color) flex items-center gap-x-1.5', className)}
      style={
        {
          '--category-color': category.color?.value || 'currentColor',
        } as React.CSSProperties
      }
    >
      {category.icon?.url && (
        <Image
          src={category.icon.url}
          alt={category.title ? `Icon for ${category.title}` : 'Category icon'}
          width={16}
          height={16}
          className='max-sm:h-auto max-sm:w-3'
        />
      )}
      {category.title}
    </div>
  );
}
